<app-report-header
  class="d-none d-print-block"
  [routeName]="route.name"
></app-report-header>

<app-report-summary
  class="d-none d-print-block mt-3"
  [route]="route"
></app-report-summary>

<h4 class="d-none d-print-block">Driving Directions Report</h4>
<div [ngClass]="{ 'scroll-modal': !printView }">
  <table id="driving-directions-table" class="table directionTable">
    <ng-container
      *ngFor="let reportLine of directionReportLines; let last = last"
    >
      <thead *ngIf="reportLine.Stop">
        <tr class="bg-gray-light">
          <th class="font-weight-bold">
            <app-report-stop
              [stop]="reportLine.Stop"
              [routeColor]="route.color"
              [stopText]="reportLine.routeAddress"
            ></app-report-stop>
          </th>

          <th
            [ngClass]="{ 'border-top-0': !reportLine.Stop }"
            class="font-weight-bold text-right"
            *ngIf="last"
          >
            {{ reportLine.Time }}
          </th>
          <th
            [ngClass]="{ 'border-top-0': !reportLine.Stop }"
            class="font-weight-bold text-right"
            *ngIf="last"
          >
            {{ reportLine.Dist | precision : precision }}
          </th>
          <th *ngIf="!last" class="font-weight-bold text-right">
            Time (Hrs/min)
          </th>
          <th *ngIf="!last" class="font-weight-bold text-right">
            {{ distanceUnits | reportsDistanceUnit }}
          </th>
        </tr>
      </thead>
      <tbody
        *ngIf="!reportLine.Stop"
        [ngClass]="{
          'no-border': reportLine?.Time,
          'no-begin': !reportLine?.Begin
        }"
      >
        <tr>
          <td
            [ngClass]="{
              'no-border ': reportLine?.Time,
              'font-weight-bold': !reportLine?.Time,
              'text-danger': reportLine?.Warn
            }"
          >
            {{ reportLine.Direction }}
          </td>
          <td
            class="text-right"
            [ngClass]="{
              'no-border': reportLine?.Time
            }"
          >
            {{ reportLine.Time }}
          </td>
          <td
            class="text-right"
            [ngClass]="{
              'no-border': reportLine?.Time
            }"
          >
            {{ reportLine.Dist | precision : precision }}
          </td>
        </tr>
      </tbody>
    </ng-container>
  </table>
  <div class="disclaimer p-2" id="driving-disclaimer">
    <span class="text-muted">{{ disclaimer }}</span>
  </div>
  <app-show-data-version [route]="route"></app-show-data-version>
</div>
